import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import router from '@/router'
import { notify } from 'notiwind'
import { useI18n } from 'vue-i18n'
import { useGlobalStore } from '@/stores/global'
import client_config from '@/assets/json/client_config.json'
import lookups from '@/assets/json/clientLookups.json'
import use124Actions from '@/composables/actions/use124Actions'

const searchFingerprintExemptionRrequests = async () => {
  const formStore = useFormStore()
  const result = await apiHelperService.get(
    `/api/icaRequest/fingerprint-exemption-requests/search/${formStore.form.values.personUnifiedNumber}`
  )
  if (result && result.length > 0) {
    formStore.extraMap.searchFingerprintExemptionRrequestsList = result
    formStore.extraMap.haveFingerprintExemptionRrequests = true
  }
}

const handleAutoSubmitValidation = async (res) => {
  const formStore = useFormStore()
  const i18n = useI18n()
  if (res.failedRuleIds && res.ticketNumber) {
    const failedRuleIdList = res.failedRuleIds.split(',')
    if (failedRuleIdList.length > 0) {
      const response = await apiHelperService.get(`/api/lookup/getRequestLogTypes`)
      if (response) {
        var logTypeText = ''
        failedRuleIdList.forEach((item) => {
          var data = response.find((m) => m.id == item)
          const localName =
            localStorage?.global?.languageId == 2 ? item.englishName : item.arabicName
          if (data != null) logTypeText = logTypeText + ', ' + localName
        })
        notify(
          {
            group: 'warning',
            title: i18n.t('errorSetDefaultAddress'),
            text: i18n.t('IssueHasbeenOpened') + res.ticketNumber + ' ' + logTypeText
          },
          6000
        )
      }
    }
    formStore.draft.request.manageFields = {}
  }
}

const handleOldAndNewEida = async () => {
  const formStore = useFormStore()
  const formDraft = formStore.draft.request
  if (
    (client_config.EnableHandlingOldEmiratesIdExceptionalList && formDraft.hasOldEmiratesIdCard) ||
    (formDraft.identityNumber && !client_config.EnableHandlingOldEmiratesIdExceptionalList)
  ) {
    formDraft.applicationRequestTypeId = lookups.applicationRequestType.renewIDCard
    formDraft.showOldEidaExpiryDate = true
    formDraft.userHadTheOldCardOrCopy = 0
    formStore.extraMap.showChangePersonPhoto = client_config.EnableChangePersonalPhoto
    if (formDraft.isFoundInExceptionalList) {
      formDraft.manageFields.isOldEidaExpiryDateDisabled = false
      if (!formDraft.identityNumber) {
        formDraft.manageFields.isIdentityNumberDisabled = false
      }
    }
  } else {
    formDraft.applicationRequestTypeId = lookups.applicationRequestType.newIDCard
    formDraft.showOldEidaExpiryDate = false
    formStore.extraMap.showChangePersonPhoto = false
  }
}

const handleDefaults = (response) => {
  const formDraft = formStore.draft.request
  const childEstablishmentId = router.currentRoute.value?.params?.childEstablishmentId
  const formStore = useFormStore()
  if (response.workPermitNumber) {
    formStore.extraMap.isWorkPermitNumberFilled = true
  }

  if (childEstablishmentId) {
    formStore.draft.request.establishmentId = childEstablishmentId
  }
  if (!formDraft.isApplicantHasDisability) formDraft.isApplicantHasDisability = 0
  if (!formDraft.isApplicantHasSocialPension) formDraft.isApplicantHasSocialPension = 0
  if (!formDraft.havePoBox) {
    formDraft.havePoBox = false
    formDraft.havePoBox = 0
  }
  if (!formDraft.oldEidaExpiryDate && formDraft.eidaCardExpiryDate) {
    formDraft.oldEidaExpiryDate = formDraft.eidaCardExpiryDate
  }
}

const loadConfigs = async (serviceTransactionId, administrativeRegionId) => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const formDraft = formStore.draft.request
  if (!serviceTransactionId && !administrativeRegionId) return
  const payload = {
    serviceTransactionId,
    administrativeRegionId
  }
  const data = await apiHelperService.get('/api/service/transactions/config', { params: payload })
  if (data && data.mainServiceTransactionId) {
    globalStore.startedService.mainServiceTransactionId = data.mainServiceTransactionId
    globalStore.startedService.entryVisaNumber = data.entryVisaNumber
    setFileNumber()
    await use124Actions('checkFines')
    if (
      parseInt(serviceTransactionId) ==
      lookups.ServiceTransactions.issueExceptionalSponsorNewBornIcaResi
    ) {
      formDraft.administrativeRegionId = lookups.adminRegions.abuDhabi
    }
  }
}

function setFileNumber() {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const formDraft = formStore.draft.request
  if (globalStore.startedService && globalStore.startedService?.isVisaFileNumberRequired) {
    globalStore.startedService.fileDepartmentCode = formDraft?.resiVisaDepartmentCode
    globalStore.startedService.fileYear = formDraft?.resiVisaYear
    globalStore.startedService.fileTypeCode = formDraft?.resiVisaServiceCode
    globalStore.startedService.fileSequenceNumber = formDraft?.resiVisaSequenceNumber
    globalStore.startedService.fileNumber =
      formDraft?.resiVisaDepartmentCode +
      formDraft.resiVisaYear +
      ('0' + formDraft.resiVisaServiceCode).slice(-2) +
      ('000000' + formDraft.resiVisaSequenceNumber).slice(-7)
    checkIfInvalidFile(lookups.module.visa)
  } else {
    globalStore.startedService.fileDepartmentCode = formDraft.resiDepartmentCode
    globalStore.startedService.fileYear = formDraft.resiYear
    globalStore.startedService.fileTypeCode = formDraft.resiServiceCode
    globalStore.startedService.fileSequenceNumber = formDraft.resiSequenceNumber
    globalStore.startedService.fileNumber =
      formDraft.resiDepartmentCode +
      formDraft.resiYear +
      ('0' + formDraft.resiServiceCode).slice(-2) +
      ('000000' + formDraft.resiSequenceNumber).slice(-7)
    checkIfInvalidFile(lookups.module.residency)
  }
}

const checkIfInvalidFile = (moduleId) => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const formDraft = formStore.draft.request
  if (globalStore.startedService.hideIdentificationInformation) return
  const { resiServiceCode, resiDepartmentCode, resiYear, resiSequenceNumber } = formDraft
  if (moduleId == lookups.module.residency) {
    if (!resiServiceCode || !resiDepartmentCode || !resiYear || !resiSequenceNumber) return
  }
  if (moduleId == lookups.module.visa) {
    if (!resiServiceCode || !resiDepartmentCode || !resiYear || !resiSequenceNumber) return
  }
}

const mapManageFields = () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const serviceTransactionId = router.currentRoute.value.params.serviceId
  const formDraft = formStore.draft.request
  if (formDraft.personUnifiedNumber) {
    formDraft.manageFields.isUnifiedNumberDisabled = true
  }
  if (formDraft.resiDepartmentCode || formDraft.resiVisaDepartmentCode) {
    formDraft.manageFields.isDepartmentCodeDisabled = true
  }
  if (formDraft.resiYear || formDraft.resiVisaYear) {
    formDraft.manageFields.isYearDisabled = true
  }
  if (formDraft.resiServiceCode || formDraft.resiVisaServiceCode) {
    formDraft.manageFields.isServiceCodeDisabled = true
  }
  if (formDraft.resiSequenceNumber || formDraft.resiVisaSequenceNumber) {
    formDraft.manageFields.isSequenceNumberDisabled = true
  }
  if (formDraft.fileIssueDate) {
    formDraft.manageFields.isFileIssueDateDisabled = true
  }
  if (formDraft.fileExpiryDate) {
    formDraft.manageFields.isFileExpiryDateDisabled = true
  }
  if (formDraft.identityNumber) {
    formDraft.manageFields.isIdentityNumberDisabled = true
  }
  if (formDraft.oldEidaExpiryDate) {
    formDraft.manageFields.isOldEidaExpiryDateDisabled = true
  }
  if (formDraft.birthCertificateNumber) {
    formDraft.manageFields.isBirthCertificateNumberDisabled = true
  }
  if (formDraft.dateOfBirth) {
    formDraft.manageFields.isDateOfBirthDisabled = true
  }
  if (formDraft.genderId && formDraft.genderId > 0) {
    formDraft.manageFields.isGenderDisabled = true
  }
  if (formDraft.sponsorRelationshipId) {
    formDraft.manageFields.isSponsorRelationshipIdDisabled = true
  }
  if (formDraft.currentNationalityId) {
    formDraft.manageFields.isCurrentNationalityIdDisabled = true
  }
  if (formDraft.previousNationalityId) {
    formDraft.manageFields.isPreviousNationalityIdDisabled = true
  }
  if (formDraft.countryOfBirthId) {
    formDraft.manageFields.isCountryOfBirthIdDisabled = true
  }
  if (formDraft.sponsoredBirthEmirateId) {
    formDraft.manageFields.isSponsoredBirthEmirateIdDisabled = true
  }
  if (formDraft.sponsoredBirthCityId) {
    formDraft.manageFields.isSponsoredBirthCityIdDisabled = true
  }
  if (formDraft.englishPlaceOfBirth) {
    formDraft.manageFields.isEnglishPlaceOfBirthDisabled = true
  }
  if (formDraft.arabicPlaceOfBirth) {
    formDraft.manageFields.isArabicPlaceOfBirthDisabled = true
  }
  if (formDraft.religionId) {
    formDraft.manageFields.isReligionIdDisabled = true
  }
  if (formDraft.maritalStatusId) {
    formDraft.manageFields.isMaritalStatusDisabled = true
  }
  if (formDraft.emailAddress) {
    formDraft.manageFields.isEmailAddressDisabled = true
  }
  if (formDraft.professionId) {
    if (
      serviceTransactionId ==
        lookups.ServiceTransactions
          .IssueResidenceAndIdentityForWorkFreezoneOrPrivateSectorSponsor ||
      serviceTransactionId ==
        lookups.ServiceTransactions.IssueResidenceAndIdentityForWorkInvestorOrPartner ||
      serviceTransactionId ==
        lookups.ServiceTransactions.establishmentForRenewresidenceandeidaForWorkForPrivatesector ||
      serviceTransactionId ==
        lookups.ServiceTransactions.RenewalResidenceAndIdentityForWorkInvestorOrPartner ||
      serviceTransactionId ==
        lookups.ServiceTransactions.IssueResidenceAndIdentityGreenResidencyForSkilledPerson ||
      serviceTransactionId == lookups.ServiceTransactions.IssueGreenResidencyForSkilledPerson
    ) {
      formDraft.manageFields.isProfessionIdDisabled = true

      if (
        serviceTransactionId ==
          lookups.ServiceTransactions
            .establishmentForRenewresidenceandeidaForWorkForPrivatesector &&
        globalStore.startedService
          .enableAutoCreateResidencyModificationRequestWhileRenewingResidencyInDifferentProfession
      ) {
        formDraft.manageFields.isProfessionIdDisabled = false
      }
    } else formDraft.manageFields.isProfessionIdDisabled = false
  }
  if (formDraft.transactionReasonId) {
    formDraft.manageFields.isTransactionReasonIdDisabled = true
  }
  if (formDraft.educationLevelId) {
    formDraft.manageFields.isEducationLevelIdDisabled = true
  }
  if (formDraft.educationLevelCountryId) {
    formDraft.manageFields.isEducationLevelCountryIdDisabled = true
  }
  if (formDraft.qualificationDescription) {
    formDraft.manageFields.isQualificationDescriptionDisabled = true
  }
  if (formDraft.workTypeId) {
    formDraft.manageFields.isWorkTypeIdDisabled = true
  }
  if (formDraft.faithId) {
    formDraft.manageFields.isFaithIdDisabled = true
  }
  if (formDraft.otherReligion) {
    formDraft.manageFields.isOtherReligionDisabled = true
  }
  if (formDraft.otherFaith) {
    formDraft.manageFields.isOtherFaithDisabled = true
  }
  if (formDraft.governmentalDepartmentId) {
    formDraft.manageFields.isGovernmentalDepartmentIdDisabled = true
  }
  if (formDraft.qualificationLevelId) {
    formDraft.manageFields.isQualificationLevelIdDisabled = true
  }

  if (formStore.form.values.religions && formDraft.religionId) {
    if (formStore.form.values.religions.filter((p) => p.id == formDraft.religionId).length == 0) {
      formDraft.manageFields.isReligionIdDisabled = false
      formDraft.religionId = undefined
      formDraft.faithId = undefined
      formDraft.manageFields.isFaithIdDisabled = false
    }
  }
}

const checkViolatedFiles = async (source) => {
  const formStore = useFormStore()
  const formDraft = formStore.draft.request
  if (source == 1) {
    if (formDraft.personUnifiedNumber == '' || formDraft.personUnifiedNumber == undefined) return
  } else if (source == 2) {
    if (
      formDraft.resiDepartmentCode == '' ||
      formDraft.resiYear == '' ||
      formDraft.resiServiceCode == '' ||
      formDraft.resiSequenceNumber == '' ||
      formDraft.resiDepartmentCode == undefined ||
      formDraft.resiYear == undefined ||
      formDraft.resiServiceCode == undefined ||
      formDraft.resiSequenceNumber == undefined
    ) {
      return
    } else {
      formStore.form.values.fileDepartmentCode = formDraft.resiDepartmentCode
      formStore.form.values.fileYear = formDraft.resiYear
      formStore.form.values.fileTypeCode = formDraft.resiServiceCode
      formStore.form.values.fileSequenceNumber = formDraft.resiSequenceNumber
    }
  } else if (source == 3) {
    if (
      formDraft.resiVisaDepartmentCode == '' ||
      formDraft.resiVisaYear == '' ||
      formDraft.resiVisaServiceCode == '' ||
      formDraft.resiVisaSequenceNumber == '' ||
      formDraft.resiVisaDepartmentCode == undefined ||
      formDraft.resiVisaYear == undefined ||
      formDraft.resiVisaServiceCode == undefined ||
      formDraft.resiVisaSequenceNumber == undefined
    ) {
      return
    } else {
      formStore.form.values.fileDepartmentCode = formDraft.resiVisaDepartmentCode
      formStore.form.values.fileYear = formDraft.resiVisaYear
      formStore.form.values.fileTypeCode = formDraft.resiVisaServiceCode
      formStore.form.values.fileSequenceNumber = formDraft.resiVisaSequenceNumber
    }
  }

  await use124Actions('checkFines')
}

const getPersonInfoAndPrepareForm = async () => {
  const formStore = useFormStore()
  const serviceTransactionId = router.currentRoute.value.params.serviceId
  const { unifiedNumber } = formStore?.form.values || {}
  if (!unifiedNumber) return
  const params = {
    serviceTransactionId: serviceTransactionId || 920,
    unifiedNumber: unifiedNumber
  }
  try {
    const response = await apiHelperService.get(
      `/api/icaRequest/draft/prepareEstablishmentUnifiedForm`,
      {
        params
      }
    )
    if (response.data) {
      formStore.draft.request = response
      formStore.form.setValues({
        personUnifiedNumber: response.unifiedNumber
      })
      if (formStore.draft.request?.personUnifiedNumber) {
        await searchFingerprintExemptionRrequests()
        try {
          const { data: res } = await apiHelperService.get(
            `/api/icaRequest/checkAutoSubmitValidation/${formStore.form.value?.personUnifiedNumber}/${serviceTransactionId || 920}`
          )
          handleAutoSubmitValidation(res)
        } catch (error) {
          console.error(error)
        }
      }
      await handleOldAndNewEida()

      handleDefaults(response)
      formStore.draft.request.withException =
        router.currentRoute.value.params.withException === 'true'
      formStore.draft.request.administrativeRegionId = response.administrativeRegionId
      formStore.draft.request.attachments = response.attachments
      loadConfigs(serviceTransactionId, response.administrativeRegionId)
      formStore.originalDraft = formStore.draft
      mapManageFields()
      checkViolatedFiles(1)
    } else {
      formStore.draft.request.personUnifiedNumber = undefined
    }
  } catch (error) {
    console.error('use920Actions', error)
  }
}

export default function () {
  return {
    getPersonInfoAndPrepareForm
  }
}
